import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { checkout } from '../utils/api';
import { Button } from '../components/ui/button';
import { CheckCircle } from 'lucide-react';

export const OrderSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    const checkPaymentStatus = async () => {
      if (!sessionId) {
        navigate('/shop');
        return;
      }

      const pollStatus = async (attempts = 0) => {
        const maxAttempts = 5;
        if (attempts >= maxAttempts) {
          setStatus('timeout');
          return;
        }

        try {
          const data = await checkout.getStatus(sessionId);
          if (data.payment_status === 'paid') {
            setStatus('success');
          } else if (data.status === 'expired') {
            setStatus('expired');
          } else {
            setTimeout(() => pollStatus(attempts + 1), 2000);
          }
        } catch (error) {
          console.error('Failed to check status', error);
          setStatus('error');
        }
      };

      pollStatus();
    };

    checkPaymentStatus();
  }, [sessionId, navigate]);

  if (status === 'checking') {
    return (
      <div className="min-h-screen section-padding flex items-center justify-center" data-testid="checking-payment">
        <div className="text-center">
          <p className="text-muted-foreground">Checking payment status...</p>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div className="min-h-screen section-padding flex items-center justify-center" data-testid="order-success-page">
        <div className="text-center space-y-6">
          <CheckCircle className="h-16 w-16 text-accent mx-auto" data-testid="success-icon" />
          <h1 className="text-4xl font-heading font-semibold" data-testid="success-title">Order Confirmed!</h1>
          <p className="text-muted-foreground" data-testid="success-message">Thank you for your purchase. Your order has been confirmed.</p>
          <Button className="btn-primary" onClick={() => navigate('/shop')} data-testid="continue-shopping-success-button">Continue Shopping</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen section-padding flex items-center justify-center" data-testid="order-error-page">
      <div className="text-center space-y-6">
        <h1 className="text-4xl font-heading font-semibold" data-testid="error-title">Payment Issue</h1>
        <p className="text-muted-foreground" data-testid="error-message">
          {status === 'expired' ? 'Payment session expired' : 'There was an issue processing your payment'}
        </p>
        <Button className="btn-primary" onClick={() => navigate('/cart')} data-testid="back-to-cart-button">Back to Cart</Button>
      </div>
    </div>
  );
};